import * as React from 'react';
import CardSection from '../../common/CardSection';

import './Dashboard.scss';
import { RouteComponentProps } from 'react-router-dom';
import { Dialog } from '@blueprintjs/core';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import { push } from 'connected-react-router';
import actions from 'src/actions';
import { connect } from 'react-redux';

interface IDashboardPageStateProps {
    warnings: {};
    isDialogShowing: boolean;
}

export interface IDashboardPageDispatchProps {
    getWarnings: (projectId: number) => void;
    assignTask: (userId: number, taskId: number) => void;
    navigate: (path: string) => void;
    setIsDialogShowing: () => void;
    hideDialog: () => void;
}

type IDashboardPageProps = RouteComponentProps<{ clientId?: string; projectId?: string }> & IDashboardPageStateProps & IDashboardPageDispatchProps;

interface IIssue {
    id: number;
    tractNumber: number;
    tractId: number;
    horizonNumber: number;
    description: string;
    assignList: Array<{ name: string; title: string; id: number }>;
}

// const issues: Array<IIssue> = [
//     {
//         id: 1,
//         tractNumber: 12,
//         tractId: 1,
//         horizonNumber: 1,
//         description: 'County not set for tract',
//         assignList: [
//             {
//                 name: 'Joe Pearson',
//                 title: 'Crew Chief',
//                 id: 1
//             },
//             {
//                 name: 'George Langston',
//                 title: 'Record Owner',
//                 id: 2
//             }
//         ]
//     },
//     {
//         id: 2,
//         tractNumber: 12,
//         tractId: 1,
//         horizonNumber: 1,
//         description: 'Ownership less than 100%',
//         assignList: [
//             {
//                 name: 'Joe Pearson',
//                 title: 'Crew Chief',
//                 id: 1
//             },
//             {
//                 name: 'George Langston',
//                 title: 'Record Owner',
//                 id: 2
//             }
//         ]
//     }
// ];

class DashboardPage extends React.Component<IDashboardPageProps> {
    viewIssue = (issue: IIssue) => {
        const clientId = this.props.match.params.clientId;
        const projectId = this.props.match.params.projectId;

        this.props.navigate(`/clients/${clientId}/projects/${projectId}/tracts/${issue.tractId}`);
    };

    showAssignDialog = (issue: IIssue) => {
        this.props.setIsDialogShowing();
    };

    showCard = (issue: IIssue) => {
        return (
            <div key={issue.id} className="warning-card">
                <div className="">{`Tract ${issue.tractNumber} Hor. ${issue.horizonNumber}`}</div>
                <div>{issue.description}</div>
                <div>
                    <button onClick={() => this.viewIssue(issue)}>View Tract</button>
                    <button onClick={() => this.showAssignDialog(issue)}>Assign Task</button>
                </div>
            </div>
        );
    };

    public render() {
        return (
            <>
                <CardSection title="Dashboard">
                    {/* <div className="project-dashboard">
                        <div className="section" style={{width: '50%'}}>
                            <div className="header">
                                Project Warnings - There are currently 2 issues in 1 tract
                            </div>
                            <div className="scroll-section">
                                {issues.map(issue => this.showCard(issue))}
                            </div>
                        </div>
                    </div> */}
                </CardSection>

                <Dialog isOpen={this.props.isDialogShowing} onClose={() => this.props.hideDialog} title="Assign Task">
                    content
                </Dialog>
            </>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    warnings: {},
    isDialogShowing: selectors.layout.isDialogShowing(state, 'assignTask'),
});

const mapDispatchToProps: IDashboardPageDispatchProps = {
    getWarnings: (projectId: number) => null,
    assignTask: (userId: number, taskId: number) => null,
    navigate: (path: string) => push(path),
    setIsDialogShowing: () => actions.layout.showDialog('assignTask'),
    hideDialog: () => actions.layout.hideDialog(),
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/project/sections/Dashboard.tsx